import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { messages } from "./languages";

// Función para limpiar el cache de idioma
export const clearLanguageCache = () => {
  localStorage.removeItem("i18nextLng");
  localStorage.removeItem("i18nextLng_es");
  localStorage.removeItem("i18nextLng_en");
  // Limpiar también los idiomas que ya no se usan
  localStorage.removeItem("i18nextLng_pt-BR");
  localStorage.removeItem("i18nextLng_tr");
};

i18n
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: "es",
    defaultNS: ["translations"],
    ns: ["translations"],
    resources: messages,
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupSessionStorage: "i18nextLng",
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      checkWhitelist: true
    }
  });

export { i18n };
